import * as Yup from "yup";
import checkout from "./form";

const {
  formField: {
    description,
    releaseDate,
    version
  },
} = checkout;

const validation = [
  Yup.object().shape({
    [description.name]:Yup.string(),
    [releaseDate.name]:Yup.date(),
    [version.name]:Yup.string(),

  }),
];

export default validation;